import { Client, User, Cart, Addresses, Restaurant, Restaurants } from '@/api'
import Vue from 'vue'
import store from '@/modules/store'
import throttle from 'lodash.throttle'
Vue.prototype.$client = Vue.observable(new Client())
Vue.prototype.$user = Vue.observable(new User())
Vue.prototype.$cart = Vue.observable(new Cart())
Vue.prototype.$addresses = Vue.observable(new Addresses())
Vue.prototype.$filteredAddresses = Vue.observable(new Addresses())
Vue.prototype.$restaurant = Vue.observable(new Restaurant())
Vue.prototype.$restaurants = Vue.observable(new Restaurants())

const throttleRefresh = throttle(async (config) => {
    try {
        return await Vue.prototype.$user.autoRefreshToken(config)
    } catch (e) {
        return false
    }
}, 60000)
Client.setErrorCallback((status, body, response, config) => {
    window.debug.warn('REQUEST ERROR', body)
    switch (status) {
        case 401: {
            if (body && process.env.NODE_ENV === 'development') {
                store.dispatch('toastWarning', {
                    title: body.title || Vue.i18n.translate('base.error_occurred'),
                    text: body.message || body.detail || null,
                })
            }
            if (config._retry) return Promise.reject(response)

            config._retry = true
            return throttleRefresh(config)
        }
        default: {
            if (body.violations) store.dispatch('site/setViolations', body.violations)
            else if (process.env.NODE_ENV === 'development')
                store.dispatch('toastWarning', {
                    title: body.title || Vue.i18n.translate('base.error_occurred'),
                    text: body.message || body.detail || null,
                })
            return
        }
    }
})
